import { createFileRoute } from '@tanstack/react-router'

import { DigitalProductLibrary } from '@/features/library'

export const Route = createFileRoute('/_event/biblioteca')({
  component: DigitalProductLibraryPage
})

function DigitalProductLibraryPage() {
  return <DigitalProductLibrary />
}
